import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";
import { ListWithLabel } from "@/components/list";

export const SOLUTIONS_CONSTANTS = {
  title: "OneMind’s GPU Solutions ",
  list: [
    {
      image: Img1,
      title: "NVIDIA T4 GPU Hosting ",
      content: (
        <ListWithLabel
          points={[
            {
              text: "Securely stream Windows & Linux applications from the cloud.",
              label: "Secure Application Streaming",
            },
            {
              text: "Multi-User & Multi-Tenant Optimization – Ideal for businesses, ISVs, and SMBs.",
              label: "Multi-Tenant Capabilities",
            },
            {
              text: "Cross-Platform Access – Access desktops from Windows, macOS, Linux, iOS, Android, and HTML5 browsers.",
              label: "Universal Access",
            },
            {
              text: "Enterprise-Grade Security – Multi-factor authentication, encrypted sessions, and 99.99% SLA uptime.",
              label: "Advanced Security Measures",
            },
            {
              text: "Pre-Validated ISV Workstations – Optimized for Adobe, Autodesk, Dassault SolidWorks, and CAD applications.",
              label: "Certified ISV Performance",
            },
            {
              text: "Remote teams, ISVs, educational institutions, and government agencies.",
              label: "Best For",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title: "NVIDIA L4 GPU Hosting ",
      content: (
        <ListWithLabel
          points={[
            {
              text: "Optimized for demanding workloads like AI/ML, CAD, and 3D modeling.",
              label: "High-Performance Compute",
            },
            {
              text: "Certified for ISV Applications – Pre-configured for Autodesk, Dassault CATIA, SolidWorks, and 3D Systems software.",
              label: "ISV Certification",
            },
            {
              text: "Enterprise-Grade Compute Power – AMD Ryzen™ PRO and Threadripper™ processors for peak performance.",
              label: "Powerful Hardware",
            },
            {
              text: "GPU-Accelerated Performance – Supports AI inference, deep learning, and 3D simulation.",
              label: "AI & 3D Optimization",
            },
            {
              text: "Multi-Session Capability – Run multiple virtual desktops on a single high-performance workstation.",
              label: "Efficient Resource Utilization",
            },
            {
              text: "Engineering, architecture, AI research, and professional ISV applications.",
              label: "Best For",
            },
          ]}
        />
      ),
    },
  ],
};
